import { Brand } from '../properties/brand';
import AnalyticsEvent from './analytics-event';
import { BrandClickOrigin, BrandClickAction } from '@monolith/legacy/types/analytics/brand-click-event';

export class BrandClickedEvent extends AnalyticsEvent {
  public readonly name = 'Brand Clicked';

  constructor(
    public readonly properties: Brand & {
      origin?: BrandClickOrigin;
      action?: BrandClickAction;
      value?: unknown;
      clicked_value?: string;
      component?: string;
      order_id?: string;
      order_reference?: string;
    }
  ) {
    super();
  }
}
